/* JSX structure for app (like html but java)
Key components:
-> video background 
-> question (i.e. header txt)
-> interactive input for text
-> interactive input for audio
-> disclaimer SMALL TXT(confidential, not sold, shared etc..)

@babel/plugin-proposal-private-property-in-object to fix error... 

TODO
->define database JSON structure with
  -> root node
    -> prompts (prompt1...promtn as key linking to string
-> use ref pathway to store input data (confessions)

-> read from database via attaching a listener
-> display via randomised grid on background (with 30% full, changing every 3s)

-> block names via linking to name database
  -> 'too personal babe, its petty' or 'don't be petty' 

*/
import React, {Suspense, useEffect, useState} from 'react';
import './App.css';
import apple_paige from './assets/websitefinal.mp4'

import { db } from './firebaseConfig';
import {ref, push, onChildAdded} from "firebase/database"

/*const setUpDB=()=>{
  const rootRef=ref()
  set(rootRef, {
    prompt1: 'i know theres something u need to confess',
    prompt2: 'got a dirty lil secret in that back pocket of urs bby?'
    //but pls, make them better
  })
}*/ 

function App(){

//define two state variables: one for inputs and one for message array (to display as ordered list)
//confession = user input
//secret = database reference 
  const [confession, setConfession] = useState("");
  const [secret, setSecrets]=useState([])

//function to add secret to database from event of inputting text
  const addConfession = async (e) => {
    e.preventDefault() 
    if (confession.trim()==="") return;
    //ADD NAME CHECKER
    const dataRef = ref(db, "prompt1");
    //push data
    push(dataRef, {
      //where confession is tree node title + variable name in react (shared variable name)
      secret: confession,
      timestamp: Date.now()
    }).catch((error)=>console.log('FAIL', error));
    setConfession("");  //clears and returns state to ""
  }

  //useEffect is a react hook that lets you synchronise a component with an external system - in this case db and secret array to display 
  useEffect(()=> {
    //attach listener, and see if new confession added to the secrets
    const unsubscribe = onChildAdded(ref(db, "prompt1"), (snapshot)=> {
      const newSecret = snapshot.val();
      setSecrets((prevSecrets)=>[...prevSecrets, newSecret.secret])
    //define unsubscribe function to detach listener
    });
    return()=> unsubscribe();
    }, []); //empty dependancy array runs once on mount CHECK


/* return html structure of webpage changed input to form in class names*/
  return (
    <div className="App">
      <div className="backbizz">
        <video 
          id="apple_video"
          autoPlay
          muted
          loop
          playsInline
          src={apple_paige}
        />
        <p className="goss">
           {secret.map(s=> <li> {s} </li>)}
        </p>
      </div>
      <div className="contents">
          <h1>hey you</h1>
            <p className="form-label">
                i know there's something u need to confess &nbsp;
              </p>
              <form 
                className="qr-secrets"
                onSubmit={addConfession}
              >
                <input className="juicy"
                  type="text"
                  value={confession}
                  onChange={(e)=>setConfession(e.target.value)}
                  placeholder="tell me..."
                />
                <button className="submission"
                  type="submit" 
                > 
                then submit
                </button>
              </form>
          <div className="smalltxt">
          <p className="disclaimer"> 
            you are submitting your secrets to bitch n bo$s for transformation
          </p>
          <p className="promote"> 
            keep in the loop w/ @ja.nkd 
          </p>
          </div>
        </div>
      </div>
   );
};
//exports app function 
export default App; 